import React from "react";
import { useHistory } from "./useHistory";
import TableQualityControl from "../../components/TableQualityControl/TableQualityControl";
import TableHistoryPPIC from "../../components/TableHistoryPPIC/TableHistoryPPIC";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import EditLogo from "../../Assets/editLogo.png";
import CloseLogo from "../../Assets/close_icon.png";
import "./History.css"; // CSS lama, jangan diubah/dihapus (dipakai komponen tabel)
import QRCode from "react-qr-code";
import { bulan } from "../../util/constant";
import { hasRole } from "../../util/utilFunction";
import moment from "moment";

/* ------------------------------------------------------------------ */
/* Helper                                                              */
/* ------------------------------------------------------------------ */

const compareMesin = (a, b) => {
  const x = Number(a.mesin);
  const y = Number(b.mesin);
  if (x < y) return -1;
  if (x > y) return 1;
  return 0;
};

const compareMesinThenText = (a, b) => {
  const byNumber = compareMesin(a, b);
  if (byNumber !== 0) return byNumber;
  if (a.mesin < b.mesin) return -1;
  if (a.mesin > b.mesin) return 1;
  return 0;
};

const formatDate = (d) =>
  d ? moment(d).utcOffset("+0700").format("DD MMM YY") : "";

const statusMeta = (isOk) => {
  if (isOk === "good") return { text: "Complete", cls: "hp_good" };
  if (isOk === "block") return { text: "Trouble", cls: "hp_block" };
  return { text: "On Progress", cls: "" };
};

/* ------------------------------------------------------------------ */
/* Komponen kecil                                                      */
/* ------------------------------------------------------------------ */

const PopUpHeader = ({ title = "", onClose }) => (
  <div className="hp_popup_header">
    <p className="hp_popup_title">{title}</p>
    <img
      className="hp_popup_close"
      src={CloseLogo}
      onClick={onClose}
      alt="close"
    />
  </div>
);

const ExportPopUp = ({
  title,
  onClose,
  onSubmit,
  label = "Kirim",
  children,
}) => (
  <PopUpComponent>
    <PopUpHeader title={title} onClose={onClose} />
    <div className="hp_popup_fields">{children}</div>
    <div className="hp_popup_footer">
      <button className="hp_btn_primary" onClick={onSubmit}>
        {label}
      </button>
    </div>
  </PopUpComponent>
);

const DateField = ({ label, value, onChange }) => (
  <div className="hp_filter_item">
    <p className="hp_filter_label">{label}</p>
    <input
      type="date"
      className="hp_input"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

const ShiftField = ({ value, onChange, withPlaceholder = false }) => (
  <div className="hp_filter_item">
    <p className="hp_filter_label">Pilih Shift</p>
    <select
      className="hp_select hp_select_shift"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {withPlaceholder && (
        <option value="Pilih Shift" disabled>
          Pilih Shift
        </option>
      )}
      <option value="1">Shift 1</option>
      <option value="2">Shift 2</option>
      <option value="3">Shift 3</option>
    </select>
  </div>
);

const MonthYearFields = ({ month, setMonth, year, setYear }) => (
  <>
    <select
      onChange={(e) => setMonth(e.target.value)}
      className="hp_select"
      value={month}
    >
      <option value="" disabled>
        Pilih Bulan
      </option>
      {bulan &&
        bulan.map((data) => (
          <option key={data.value} value={data.value}>
            {data.name}
          </option>
        ))}
    </select>
    <select
      onChange={(e) => setYear(e.target.value)}
      className="hp_select hp_select_year"
      value={year}
    >
      <option value="" disabled>
        Pilih Tahun
      </option>
      <option value="2025">2025</option>
      <option value="2026">2026</option>
    </select>
  </>
);

const ToolbarButton = ({ children, onClick }) => (
  <button type="button" className="hp_btn_green" onClick={onClick}>
    {children}
  </button>
);

/* Satu baris status (Mold / Produksi / Quality) di kartu ganti mold */
const StatusRow = ({ no, label, status, approver, date }) => {
  const meta = statusMeta(status.isOk);
  return (
    <div className="hp_status_row hp_text">
      <span>{no}.</span>
      <span>{label}</span>
      <span className={`hp_chip ${meta.cls}`}>{meta.text}</span>
      <span>{approver}</span>
      <span className="hp_status_date">
        <span>{date}</span>
        <span>{status.time}</span>
      </span>
    </div>
  );
};

/* Kartu ganti mold (dipakai untuk "utama" dan "satuan") */
const GantiMoldCard = ({
  obj,
  jenis,
  dateLabel,
  hideEdit,
  onEdit,
  commentValue,
  onCommentChange,
  onSend,
}) => {
  const utama = jenis === "utama";
  const approverName = (name) =>
    utama ? (name || "").split(" ").slice(0, 1).join(" ") : name;

  return (
    <div className="hp_card">
      {/* Header */}
      <div className="hp_card_head hp_card_head_top hp_text">
        <p className="hp_bold">
          Mesin {obj.mesin}
          {utama && obj.urutan && (
            <>
              <span>&nbsp;-&nbsp;</span>
              <span className="hp_red_strong">{obj.urutan}</span>
            </>
          )}
          {utama && (
            <>
              <br />
              <span className="hp_red">{obj.jenis}</span>
            </>
          )}
        </p>
        <p className="hp_bold">
          {obj.customer}
          {utama && (
            <>
              <br />
              {dateLabel}
            </>
          )}
        </p>
        <div className="hp_card_edit">
          {!hideEdit && (
            <img
              className="hp_card_edit_icon"
              src={EditLogo}
              onClick={onEdit}
              alt="edit_logo"
            />
          )}
        </div>
      </div>

      {/* Mold / warna / total */}
      <div className="hp_card_head hp_text">
        <p className="hp_bold">{obj.moldProduk}</p>
        <p>{obj.color}</p>
        <p className="hp_bold">
          {obj.totalBahan ? (
            <>
              {obj.totalBahan} Pcs
              {utama && (
                <>
                  <br />
                  STOP
                </>
              )}
            </>
          ) : (
            ""
          )}
        </p>
      </div>

      {/* Status */}
      <div className="hp_status">
        <StatusRow
          no={1}
          label="Mold"
          status={obj.statusMold}
          approver={approverName(obj.statusMold.approver)}
          date={utama ? formatDate(obj.statusMold.date) : obj.statusMold.date}
        />
        <StatusRow
          no={2}
          label="Produksi"
          status={obj.statusProduksi}
          approver={approverName(obj.statusProduksi.approver)}
          date={
            utama
              ? formatDate(obj.statusProduksi.date)
              : obj.statusProduksi.date
          }
        />
        <StatusRow
          no={3}
          label="Quality"
          status={obj.statusQuality}
          approver={approverName(obj.statusQuality.approver)}
          date={obj.statusQuality.date}
        />
      </div>

      {/* Comment */}
      <textarea
        className="hp_textarea"
        value={commentValue}
        onChange={(e) => onCommentChange(e.target.value)}
        placeholder="Comment"
      />
      <div className="hp_popup_footer">
        <button className="hp_btn_primary" onClick={onSend}>
          Kirim
        </button>
      </div>

      {obj.comment &&
        obj.comment.map((data, i) => (
          <div className="hp_comment" key={i}>
            <p className="hp_comment_name">
              {data.name} - {data.time}
            </p>
            <p className="hp_comment_desc">{data.desc}</p>
          </div>
        ))}
    </div>
  );
};

/* ------------------------------------------------------------------ */
/* Halaman                                                             */
/* ------------------------------------------------------------------ */

const History = () => {
  const {
    subMenuHistory,
    setSubMenuHistory,
    handleSubMenuHistory,
    dataHistoryPPIC,
    dateHistoryPPIC,
    handleChangeDate,
    dateQc,
    setDateQc,
    shiftQc,
    setShiftQc,
    dataQc,
    memoGanti,
    dataUser,
    shiftProduksi,
    setShiftProduksi,
    dateProduksi,
    setDateProduksi,
    historyDataOperator,
    handleEditChecklist,
    popUpGantiMold,
    setPopUpGantiMold,
    setCommentGantiMold,
    commentGantiMold,
    handleKirimComment,
    exportLaporanProduksi,
    exportDataCycleTime,
    popUpLaporanProduksi,
    setPopUpLaporanProduksi,
    dariTanggalLaporanProduksi,
    setDariTanggalLaporanProduksi,
    sampaiTanggalLaporanProduksi,
    setSampaiTanggalLaporanProduksi,
    listTopPlate,
    dateCycleTime,
    setDateCycleTime,
    dateLaporanPasangKaret,
    setDateLaporanPasangKaret,
    dataLaporanPasangKaret,
    dateUntilLaporanPasangKaret,
    setDateUntilLaporanPasangKaret,
    exportVentPlug,
    dataDetailProduk,
    shiftVP,
    setShiftVP,
    exporDataBerat,
    bulanExport,
    setBulanExport,
    tahunExport,
    setTahunExport,
    qrCode,
    handleComment,
    popUpPasangSticker,
    setPopUpPasangSticker,
    filterMonth,
    setFilterMonth,
    filterYear,
    setFilterYear,
    exporDataPasangStiker,
    popUpPasangToco,
    setPopUpPasangToco,
    exporDataPasangToco,
  } = useHistory();

  // ---------- hak akses (multi role) ----------
  const canLaporanProduksi = hasRole(
    dataUser,
    "super_user",
    "qc_admin",
    "produksi_admin",
    "ppic_admin"
  );
  const canVentPlug = hasRole(
    dataUser,
    "super_user",
    "produksi_admin",
    "ppic_admin"
  );
  const canQc = hasRole(
    dataUser,
    "super_user",
    "ppic_admin",
    "qc_user",
    "qc_admin",
    "produksi_admin",
    "produksi_leader"
  );
  const canDetailProduk = hasRole(
    dataUser,
    "super_user",
    "qc_user",
    "qc_admin"
  );

  // true = ikon edit disembunyikan
  const hideEditLogo = (obj) =>
    (hasRole(dataUser, "mold_admin", "mold_user") &&
      obj.statusMold.isOk === "good") ||
    (hasRole(dataUser, "mesin_admin", "mesin_user") &&
      obj.statusMesin.isOk === "good") ||
    (hasRole(dataUser, "warehouse_admin", "warehouse_mixing") &&
      obj.statusWarehouse.isOk === "good") ||
    (hasRole(dataUser, "produksi_leader") &&
      obj.statusProduksi.isOk === "good") ||
    (hasRole(dataUser, "qc_admin", "qc_user") &&
      obj.statusQuality.isOk === "good") ||
    hasRole(dataUser, "ppic_admin");

  // ---------- data ----------
  const dataUtama = memoGanti && memoGanti.utama;
  const dataSatuan = memoGanti && memoGanti.satuan;

  const sortData =
    historyDataOperator && historyDataOperator.sort(compareMesin);
  const sortDataPPIC = dataHistoryPPIC && dataHistoryPPIC.sort(compareMesin);
  const sortDataQuality = dataQc && dataQc.data.sort(compareMesin);
  const sortDataTopPlate = listTopPlate && listTopPlate.sort(compareMesin);
  const sortDataPasangKaret =
    dataLaporanPasangKaret && dataLaporanPasangKaret.sort(compareMesinThenText);

  // ---------- tab ----------
  const tabs = [
    {
      key: "laporanProduksi",
      label: "Laporan Produksi",
      show: canLaporanProduksi,
      onClick: () => setSubMenuHistory("laporanProduksi"),
    },
    {
      key: "ventPlug",
      label: "Vent Plug",
      show: canVentPlug,
      onClick: () => setSubMenuHistory("ventPlug"),
    },
    {
      key: "qc",
      label: "QC",
      show: canQc,
      onClick: () => setSubMenuHistory("qc"),
    },
    {
      key: "detailProduk",
      label: "Detail Produk",
      show: canDetailProduk,
      onClick: () => setSubMenuHistory("detailProduk"),
    },
    {
      key: "ppic",
      label: "PPIC",
      show: true,
      onClick: () => handleSubMenuHistory("ppic"),
    },
    {
      key: "gantiMold",
      label: "Ganti Produksi",
      show: true,
      onClick: () => handleSubMenuHistory("gantiMold"),
    },
  ];

  // ---------- pop up export ----------
  const closeExportPopUp = () => setPopUpLaporanProduksi("");

  const renderExportPopUp = () => {
    if (popUpLaporanProduksi === "laporanProduksi") {
      return (
        <ExportPopUp
          title="Laporan Produksi"
          onClose={closeExportPopUp}
          onSubmit={() => exportLaporanProduksi()}
        >
          <DateField
            label="Dari"
            value={dariTanggalLaporanProduksi}
            onChange={setDariTanggalLaporanProduksi}
          />
          <DateField
            label="Sampai"
            value={sampaiTanggalLaporanProduksi}
            onChange={setSampaiTanggalLaporanProduksi}
          />
        </ExportPopUp>
      );
    }
    if (popUpLaporanProduksi === "dataCycleTime") {
      return (
        <ExportPopUp
          title="Data Cycle Time"
          onClose={closeExportPopUp}
          onSubmit={() => exportDataCycleTime()}
        >
          <DateField
            label="Tanggal"
            value={dateCycleTime}
            onChange={setDateCycleTime}
          />
        </ExportPopUp>
      );
    }
    if (popUpLaporanProduksi === "pasangKaret") {
      return (
        <ExportPopUp
          title="Pasang Karet"
          onClose={closeExportPopUp}
          onSubmit={() => exportVentPlug()}
        >
          <DateField
            label="Dari"
            value={dateLaporanPasangKaret}
            onChange={setDateLaporanPasangKaret}
          />
          <DateField
            label="Sampai"
            value={dateUntilLaporanPasangKaret}
            onChange={setDateUntilLaporanPasangKaret}
          />
        </ExportPopUp>
      );
    }
    return null;
  };

  return (
    <div className="hp_root">
      {renderExportPopUp()}

      {popUpGantiMold && (
        <PopUpComponent>
          <PopUpHeader onClose={() => setPopUpGantiMold(false)} />
          <div className="hp_popup_qr">
            <QRCode
              value={qrCode}
              style={{ width: "148px", height: "148px" }}
            />
          </div>
        </PopUpComponent>
      )}

      {popUpPasangSticker && (
        <ExportPopUp
          onClose={() => setPopUpPasangSticker(false)}
          onSubmit={() => exporDataPasangStiker()}
          label="Export"
        >
          <MonthYearFields
            month={filterMonth}
            setMonth={setFilterMonth}
            year={filterYear}
            setYear={setFilterYear}
          />
        </ExportPopUp>
      )}

      {popUpPasangToco && (
        <ExportPopUp
          onClose={() => setPopUpPasangToco(false)}
          onSubmit={() => exporDataPasangToco()}
          label="Export"
        >
          <MonthYearFields
            month={filterMonth}
            setMonth={setFilterMonth}
            year={filterYear}
            setYear={setFilterYear}
          />
        </ExportPopUp>
      )}

      <p className="hp_title">HISTORY</p>

      <div className="hp_tabs">
        {tabs
          .filter((tab) => tab.show)
          .map((tab) => (
            <p
              key={tab.key}
              className={
                subMenuHistory === tab.key ? "hp_tab hp_tab_active" : "hp_tab"
              }
              onClick={tab.onClick}
            >
              {tab.label}
            </p>
          ))}
      </div>

      {/* ===================== QC ===================== */}
      {subMenuHistory === "qc" && (
        <TableQualityControl
          dateQc={dateQc}
          setDateQc={setDateQc}
          shiftQc={shiftQc}
          setShiftQc={setShiftQc}
          dataQc={sortDataQuality && sortDataQuality}
          dataTopPlate={sortDataTopPlate && sortDataTopPlate}
          exportBerat={exporDataBerat}
          bulanExport={bulanExport}
          setBulanExport={setBulanExport}
          tahunExport={tahunExport}
          setTahunExport={setTahunExport}
        />
      )}

      {/* ===================== PPIC ===================== */}
      {subMenuHistory === "ppic" && (
        <>
          <p className="hp_title">Bahan Baku</p>
          <div className="hp_filter_bar">
            <DateField
              label="Pilih Tanggal"
              value={dateHistoryPPIC}
              onChange={(value) => handleChangeDate({ target: { value } })}
            />
          </div>
          <TableHistoryPPIC data={sortDataPPIC} jenisBahan="BAKU" />
          <br />
        </>
      )}

      {/* ===================== GANTI PRODUKSI ===================== */}
      {subMenuHistory === "gantiMold" && (
        <>
          <div className="hp_filter_bar">
            <DateField
              label="Pilih Tanggal"
              value={dateHistoryPPIC}
              onChange={(value) => handleChangeDate({ target: { value } })}
            />
          </div>

          <div className="hp_list">
            {dataUtama &&
              dataUtama.map((obj) => (
                <GantiMoldCard
                  key={obj.id}
                  obj={obj}
                  jenis="utama"
                  dateLabel={moment(dateHistoryPPIC)
                    .utcOffset("+0700")
                    .format("DD/MM/YY")}
                  hideEdit={hideEditLogo(obj)}
                  onEdit={() => handleEditChecklist(obj, "utama")}
                  commentValue={
                    commentGantiMold && commentGantiMold.id === obj.id
                      ? commentGantiMold.newComment
                      : ""
                  }
                  onCommentChange={(value) => handleComment(obj, value)}
                  onSend={() => handleKirimComment(obj.mesin, "utama", obj.id)}
                />
              ))}

            {dataSatuan &&
              dataSatuan.map((obj, index) => (
                <GantiMoldCard
                  key={obj.id || `satuan-${index}`}
                  obj={obj}
                  jenis="satuan"
                  hideEdit={hideEditLogo(obj)}
                  onEdit={() => handleEditChecklist(obj, "satuan")}
                  commentValue={
                    typeof commentGantiMold === "string" ? commentGantiMold : ""
                  }
                  onCommentChange={setCommentGantiMold}
                  onSend={() => handleKirimComment(obj.mesin, "satuan")}
                />
              ))}
          </div>
        </>
      )}

      {/* ===================== LAPORAN PRODUKSI ===================== */}
      {subMenuHistory === "laporanProduksi" && canLaporanProduksi && (
        <>
          <div className="hp_filter_bar" id="data-history-laporan-produksi">
            <ShiftField value={shiftProduksi} onChange={setShiftProduksi} />
            <DateField
              label="Pilih Tanggal"
              value={dateProduksi}
              onChange={setDateProduksi}
            />
            <div className="hp_toolbar">
              <ToolbarButton
                onClick={() => setPopUpLaporanProduksi("laporanProduksi")}
              >
                Laporan
                <br />
                Produksi
              </ToolbarButton>
              <ToolbarButton
                onClick={() => setPopUpLaporanProduksi("dataCycleTime")}
              >
                Data
                <br />
                Cycle Time
              </ToolbarButton>
              <ToolbarButton onClick={() => setPopUpPasangSticker(true)}>
                Pasang
                <br />
                Sticker
              </ToolbarButton>
              <ToolbarButton onClick={() => setPopUpPasangToco(true)}>
                Pasang
                <br />
                Toco
              </ToolbarButton>
            </div>
          </div>

          <div id="container" className="hp_table_scroll">
            <table className="hp_table">
              <thead>
                <tr>
                  <th>Mesin</th>
                  <th>Cust</th>
                  <th>Produk</th>
                  <th>Operator</th>
                  <th>Isi Per Kemasan</th>
                  <th>Aktual Cavity</th>
                  <th>Counter Akhir</th>
                  <th>Counter Awal</th>
                  <th>Selisih Counter</th>
                  <th>Jumlah OK</th>
                  <th>Jumlah "NG"</th>
                  <th>Total Produksi</th>
                  <th>Down Time</th>
                  <th>Cycle Time</th>
                  <th>Perincian "NG"</th>
                  <th>Jumlah</th>
                  <th>Edited By</th>
                  <th>Edited Admin</th>
                  <th>Keterangan</th>
                </tr>
              </thead>
              <tbody>
                {sortData &&
                  sortData.map((obj, index) => {
                    const downtime = obj.downtime ? obj.downtime : 0;
                    const counterAwal = obj.counterAwal ? obj.counterAwal : 0;
                    const counterAkhir = obj.counterAkhir
                      ? obj.counterAkhir
                      : 0;
                    const cycleTime =
                      (28800 - downtime * 60) / (counterAkhir - counterAwal);

                    return (
                      <tr key={index}>
                        <td className="hp_cell_mesin">{obj.mesin}</td>
                        <td>{obj.customer}</td>
                        <td className="hp_nowrap hp_cell_produk">
                          {obj.moldType}
                        </td>
                        <td className="hp_nowrap">{obj.operator}</td>
                        <td>{obj.isiPerKemasan}</td>
                        <td>{obj.aktualCavity}</td>
                        <td>{obj.counterAkhir}</td>
                        <td>{obj.counterAwal}</td>
                        <td>{obj.counterAkhir - obj.counterAwal}</td>
                        <td>{obj.jumlahBarang}</td>
                        <td>{obj.jumlahNG}</td>
                        <td>{obj.jumlahBarang + obj.jumlahNG}</td>
                        <td>{downtime}</td>
                        <td>{cycleTime.toFixed(1)}</td>
                        <td className="hp_nowrap hp_cell_ng">
                          {obj.perincianNG &&
                            obj.perincianNG.map((ng, i) => (
                              <p key={i}>{ng.id}</p>
                            ))}
                        </td>
                        <td className="hp_nowrap hp_cell_ng">
                          {obj.perincianNG &&
                            obj.perincianNG.map((ng, i) => (
                              <p key={i}>{ng.totalNG}</p>
                            ))}
                        </td>
                        <td className="hp_nowrap">{obj.editedBy}</td>
                        <td className="hp_nowrap hp_cell_admin">
                          {obj.editedByAdmin}
                        </td>
                        <td className="hp_cell_ket">
                          {obj.keterangan !== "" || dataUser.tim === 2 ? (
                            <div>
                              {obj.keterangan &&
                                obj.keterangan
                                  .split("\n")
                                  .map((line, i) => <p key={i}>{line}</p>)}
                            </div>
                          ) : (
                            (obj.dataKeterangan || []).map((ele, i) => (
                              <div className="hp_ket_row" key={i}>
                                <div className="hp_ket_jam">{ele.jam}</div>
                                <div className="hp_ket_text">
                                  {ele.keterangan}
                                </div>
                              </div>
                            ))
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ===================== VENT PLUG ===================== */}
      {subMenuHistory === "ventPlug" && (
        <>
          <div className="hp_filter_bar">
            <ShiftField value={shiftVP} onChange={setShiftVP} />
            <DateField
              label="Pilih Tanggal"
              value={dateLaporanPasangKaret}
              onChange={setDateLaporanPasangKaret}
            />
            <div className="hp_toolbar">
              <ToolbarButton
                onClick={() => setPopUpLaporanProduksi("pasangKaret")}
              >
                Laporan
                <br />
                Pasang Karet
              </ToolbarButton>
            </div>
          </div>

          <div className="hp_table_scroll">
            <table className="hp_table">
              <thead>
                <tr>
                  <th>Mesin</th>
                  <th>Nama Vent Plug</th>
                  <th>Warna</th>
                  <th>Cust.</th>
                  <th>Operator</th>
                  <th>Downtime</th>
                  <th>Cavity</th>
                  <th>Jumlah (Pcs)</th>
                  <th>Keterangan</th>
                </tr>
              </thead>
              <tbody>
                {sortDataPasangKaret &&
                  sortDataPasangKaret
                    .filter((element) => element.shift === shiftVP)
                    .map((element, index) => (
                      <tr key={index}>
                        <td className="hp_cell_mesin">{element.mesin}</td>
                        <td className="hp_nowrap">{element.produk}</td>
                        <td>{element.warna}</td>
                        <td>{element.customer}</td>
                        <td className="hp_cell_operator">{element.operator}</td>
                        <td>{element.downtime}</td>
                        <td>{element.aktualCavity}</td>
                        <td>{element.jumlah}</td>
                        <td className="hp_cell_ket_vp">{element.keterangan}</td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* ===================== DETAIL PRODUK ===================== */}
      {subMenuHistory === "detailProduk" && (
        <>
          <div className="hp_filter_bar">
            <ShiftField value={shiftQc} onChange={setShiftQc} withPlaceholder />
            <DateField
              label="Pilih Tanggal"
              value={dateQc}
              onChange={setDateQc}
            />
          </div>

          <div className="hp_table_scroll">
            <table className="hp_table">
              <thead>
                <tr>
                  <th>Mold</th>
                  <th>CHECKER</th>
                  {Array.from({ length: 10 }, (_, i) => (
                    <th key={i}>Cav {i + 1}</th>
                  ))}
                  <th>Berat TOCO</th>
                  <th>Berat RUNNER</th>
                </tr>
              </thead>
              <tbody>
                {dataDetailProduk &&
                  dataDetailProduk.map((element, index) => (
                    <tr key={index}>
                      <td className="hp_nowrap">{element.mold}</td>
                      <td>{element.checker}</td>
                      {element.dataCavity.map((cav, i) => (
                        <td key={i}>{cav.berat}</td>
                      ))}
                      <td>{element.toco}</td>
                      <td>{element.runner}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default History;
